import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";

import NewOrder from "../views/NewOrder.vue";
import NewMenu from "../views/NewMenu.vue";
import NewCart from "../views/NewCart.vue";
import OrderHistory from "../views/OrderHistory.vue";

import CashierNotes from "../views/CashierNotes.vue";
import NotesList from "../views/NotesList.vue";

import OrderDetail from "../components/OrderDetail/OrderDetail.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/detail/:id",
        name: "OrderDetail",
        component: OrderDetail,
    },
    {
        path: "/neworder",
        name: "NewOrder",
        component: NewOrder,
    },
    {
        path: "/newmenu",
        name: "NewMenu",
        component: NewMenu,
    },
    {
        path: "/newcart",
        name: "NewCart",
        component: NewCart,
    },
    {
        path: "/newnotes",
        name: "CashierNotes",
        component: CashierNotes,
    },
    {
        path: "/noteslist",
        name: "NotesList",
        component: NotesList,
    },
    {
        path: "/history",
        name: "OrderHistory",
        component: OrderHistory,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
